import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableCell, TableRow, CellContent } from '../../styled-components/Table';
import Constants from '../../constants/mapStatusTable';
import LuciPropTypes from '../../propTypes/';

class MapStatusTable extends Component {
  render() {
    const { maps } = this.props;
    return (
      <Table fontSize="11px" width="100%">
        <TableBody overflowY="scroll">
          {maps.map(map => (
            <TableRow key={map.jobId}>
              <TableCell width={Constants.TITLE_COLUMN_WIDTH}>
                <CellContent>{map.title}</CellContent>
              </TableCell>
              <TableCell width={Constants.STATUS_COLUMN_WIDTH}>
                <CellContent>{map.status}</CellContent>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
}

MapStatusTable.defaultProps = {
  maps: []
};

MapStatusTable.propTypes = {
  maps: PropTypes.arrayOf(LuciPropTypes.AxisOrder)
};

export default MapStatusTable;



// WEBPACK FOOTER //
// ./app/components/DeliveryStatus/MapStatusTable.js